import { BestFlashSale, SpecialOffer, WeekendSale } from "../../../utils/Constant";

export const WeekendSaleData = [
    {
        image:"01",
        title:WeekendSale,
        subTitle:"Acer Aspire 5 Gaming Intel Core",
        star:"4.5",
        btn:"Hot",
        amount:"$26.00",
        disAmount:"$30.00"
    },
    {
        image:"02",
        title:SpecialOffer,
        subTitle:"Airpods 3rd Generation Silicone",
        star:"4.5",
        btn:"50%",
        amount:"$41.00",
        disAmount:"$45.00"
    },
    {
        image:"03",
        title:BestFlashSale,
        subTitle:"Smartwatch with Alexa Built-in",
        star:"4.5",
        btn:"Hot",
        amount:"$34.00",
        disAmount:"$32.00"
    }
]